import util from '../util/util.js';
// @vite-ignore 
import * as jQuery from '../../lib/jquery/jquery-3.1.1.min.js';
const $ = jQuery

/**
 * The maximum number of items kept in local history for a specific WH output.
 *
 * @type {number}
 */
const HISTORY_ITEMS_MAX_COUNT = 30;

/**
 * Test if a browser local storage is available.
 *
 * @returns {boolean} Returns true if local storage is available.
 */
function localStorageAvailable() {
    try {
        const storage = window['localStorage'],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        util.debug(e);
        return false;
    }
}

/**
 * @returns {string} Get the key to use for reading from local storage. It is unique for a WH output.
 */
function getSearchHistoryKey() {
    let wh_root = $('meta[name=wh-path2root]').attr('content');
    if (wh_root == null || wh_root == undefined || wh_root.length == 0) {
        wh_root = 'index.html';
    } else {
        wh_root += 'index.html';
    }

    const wh_root_path = resolveRelativePath(wh_root);
    return wh_root_path + '_search_history_items';
}

/**
 * Resolve a relative path to the current browser location.
 *
 * @param relPath The relative path to resolve.
 * @returns {string} The resolved URL.
 */
function resolveRelativePath(relPath) {
    const link = document.createElement('a');
    link.href = relPath;
    return link.protocol + '//' + link.host + link.pathname + link.search + link.hash;
}

/**
 * Add a search query to the history.
 *
 * @param searchQuery The search query to add.
 */
function addSearchQueryToHistory(searchQuery) {
    util.debug('Add search query to history: ', searchQuery);
    if (localStorageAvailable()) {
        searchQuery = searchQuery.toLowerCase();
        const localStorageKey = getSearchHistoryKey();
        try {
            const localStorageItems = window.localStorage.getItem(localStorageKey);
            if (!localStorageItems) {
                // Local storage is empty for the current WH output.
                const hItemsArray = [];
                hItemsArray.push(searchQuery);
                const valToSave = JSON.stringify(hItemsArray);
                util.debug('Save to local storage: ', valToSave);
                window.localStorage.setItem(localStorageKey, valToSave);
            } else {
                // There are local storage items for current WH output
                const lastSearchItemsArray = JSON.parse(localStorageItems);
                const idx = lastSearchItemsArray.indexOf(searchQuery);
                if (idx != -1) {
                    // Promote history item
                    util.debug('Promote history item:', lastSearchItemsArray);
                    lastSearchItemsArray.splice(idx, 1);
                }

                // Add first
                lastSearchItemsArray.unshift(searchQuery);

                // Ensure local history items  do not exceed the MAX limit
                if (lastSearchItemsArray.length > HISTORY_ITEMS_MAX_COUNT) {
                    lastSearchItemsArray.splice(HISTORY_ITEMS_MAX_COUNT);
                }

                // Save to local storage.
                const newVal = JSON.stringify(lastSearchItemsArray);
                window.localStorage.setItem(localStorageKey, newVal);
            }
        } catch (e) {
            util.debug('Exception when trying to save to local storage: ', e);
            window.localStorage.removeItem(localStorageKey);
        }
    } else {
        util.debug('Local storage is not available');
    }
}

/**
 * Get the search history items from local storage.
 *
 * @returns {Array} The array with search history items.
 */
function getHistorySearchItems() {
    const toRet = [];
    if (localStorageAvailable()) {
        const localStorageKey = getSearchHistoryKey();

        try {
            const lastLocalStorage = window.localStorage.getItem(localStorageKey);
            if (lastLocalStorage) {
                // Convert to array
                const lastSearchItemsArray = JSON.parse(lastLocalStorage);

                if (Array.isArray(lastSearchItemsArray)) {
                    return lastSearchItemsArray;
                }
            }
        } catch (e) {
            util.debug('Exception when reading from local storage: ', e);
            window.localStorage.removeItem(localStorageKey);
        }
    }

    return toRet;
}

/**
 * Remove from local storage a history item.
 *
 * @param historyItem The history item to remove.
 * @returns {boolean} True if item was removed.
 */
function removeSearchHistoryItem(historyItem) {
    let removed = false;
    if (localStorageAvailable()) {
        const localStorageKey = getSearchHistoryKey();

        try {
            const lastLocalStorage = window.localStorage.getItem(localStorageKey);
            if (lastLocalStorage) {
                // Convert to array
                const lastSearchItemsArray = JSON.parse(lastLocalStorage);

                if (Array.isArray(lastSearchItemsArray)) {
                    historyItem = historyItem.toLowerCase();
                    const idx = lastSearchItemsArray.indexOf(historyItem);
                    if (idx != -1) {
                        // Remove from local storage
                        lastSearchItemsArray.splice(idx, 1);
                        const newVal = JSON.stringify(lastSearchItemsArray);
                        window.localStorage.setItem(localStorageKey, newVal);

                        removed = true;
                    }
                }
            }
        } catch (e) {
            util.debug('Exception when removing from local storage: ', e);
            window.localStorage.removeItem(localStorageKey);
        }
    }

    return removed;
}

export default {
    addSearchQueryToHistory,
    getHistorySearchItems,
    removeSearchHistoryItem
};
